import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { whatsappLink } from "../lib/site";

export const WhatsAppIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.43 9.43 0 1 1 8 4.42zm8.02-17.45A11.27 11.27 0 0 0 12.05.72C5.8.72.72 5.8.72 12.05c0 2 .52 3.95 1.52 5.66L.62 23.6l6.03-1.58a11.3 11.3 0 0 0 5.4 1.38h.01c6.25 0 11.33-5.08 11.33-11.33 0-3.03-1.18-5.87-3.32-8.02z" />
  </svg>
);

export const WhatsAppFab = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const f = () => setShow(window.scrollY > window.innerHeight * 0.7);
    f();
    window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);
  return (
  <AnimatePresence>
  {show && (
  <motion.a
    href={whatsappLink("Olá! Vim pelo site da NEXUS e gostaria de conversar sobre um projeto.")}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-fab"
    aria-label="Conversar no WhatsApp"
    initial={{ opacity: 0, y: 20, scale: 0.9 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    exit={{ opacity: 0, y: 20, scale: 0.9 }}
    transition={{ duration: 0.6, ease: [0.2, 0.8, 0.2, 1] }}
    className="wa-fab group fixed z-[55] right-4 bottom-[max(1rem,env(safe-area-inset-bottom))] sm:right-6 sm:bottom-6 flex items-center gap-3 h-14 pl-2 pr-2 sm:pr-5 rounded-full bg-[#0b0b0b]/80 backdrop-blur-xl border border-[#D4AF5A]/35 shadow-[0_20px_50px_-15px_rgba(0,0,0,.9)]"
  >
    <span className="relative grid place-items-center h-10 w-10 rounded-full bg-gradient-to-b from-[#e2c37a] to-[#b8923f] text-[#050505]">
      <span className="absolute inset-0 rounded-full border border-[#D4AF5A] animate-[waPing_3.2s_ease-out_infinite]" />
      <WhatsAppIcon size={20} />
    </span>
    <span className="hidden sm:flex flex-col leading-tight pr-1">
      <span className="text-[10px] font-mono tracking-[0.16em] uppercase text-[#A7A7AD]">Atendimento</span>
      <span className="text-sm font-semibold text-[#F5F3EE] group-hover:text-[#D4AF5A] transition-colors">Fale no WhatsApp</span>
    </span>
  </motion.a>
  )}
  </AnimatePresence>
  );
};
